import { useLanguage } from '../../../contexts/useLanguage';

export default function Features() {
  const { language } = useLanguage();

  const content = {
    zh: {
      subtitle: 'Features',
      title: '强大功能 释放创意',
      description: '从创意构思到成品输出，AI漫画生成器为你提供完整的漫画创作工具链',
      features: [
        {
          icon: 'ri-magic-line',
          title: 'AI漫画生成',
          description: '输入创意文字，AI自动生成精美漫画画面，支持多种风格和场景',
          color: 'from-red-500 to-pink-500',
        },
        {
          icon: 'ri-film-line',
          title: '动画短片制作',
          description: '将静态漫画转化为动态短片，添加音效和音乐，打造属于你的动画作品',
          color: 'from-purple-500 to-indigo-500',
        },
        {
          icon: 'ri-edit-box-line',
          title: '分镜编辑',
          description: '自由编辑对话和叙事文字，或使用AI自动生成剧情内容',
          color: 'from-blue-500 to-cyan-500',
        },
        {
          icon: 'ri-palette-line',
          title: '多样化风格',
          description: '提供漫画、卡通、赛博朋克等多种艺术风格，满足不同创作需求',
          color: 'from-teal-500 to-green-500',
        },
        {
          icon: 'ri-share-line',
          title: '一键分享',
          description: '轻松将作品分享到社交平台，与全球创作者互动交流',
          color: 'from-orange-500 to-yellow-500',
        },
        {
          icon: 'ri-download-cloud-line',
          title: '高清导出',
          description: '支持高清画质导出，保存你的创作成果，随时随地欣赏',
          color: 'from-pink-500 to-rose-500',
        },
      ]
    },
    en: {
      subtitle: 'Features',
      title: 'Powerful Features Unleash Creativity',
      description: 'From creative conception to finished output, AiComic provides you with a complete comic creation toolchain',
      features: [
        {
          icon: 'ri-magic-line',
          title: 'AI Comic Generation',
          description: 'Input creative text, AI automatically generates beautiful comic panels, supporting multiple styles and scenes',
          color: 'from-red-500 to-pink-500',
        },
        {
          icon: 'ri-film-line',
          title: 'Animated Short Production',
          description: 'Convert static comics into dynamic shorts, add sound effects and music, create your own animations',
          color: 'from-purple-500 to-indigo-500',
        },
        {
          icon: 'ri-edit-box-line',
          title: 'Storyboard Editing',
          description: 'Freely edit dialogues and narrative text, or use AI to automatically generate plot content',
          color: 'from-blue-500 to-cyan-500',
        },
        {
          icon: 'ri-palette-line',
          title: 'Diverse Styles',
          description: 'Offers comic, cartoon, cyberpunk and other art styles to meet different creative needs',
          color: 'from-teal-500 to-green-500',
        },
        {
          icon: 'ri-share-line',
          title: 'One-Click Sharing',
          description: 'Easily share your works to social platforms, interact and exchange with global creators',
          color: 'from-orange-500 to-yellow-500',
        },
        {
          icon: 'ri-download-cloud-line',
          title: 'HD Export',
          description: 'Supports high-definition quality export, save your creations, enjoy anytime anywhere',
          color: 'from-pink-500 to-rose-500',
        },
      ]
    }
  };

  const t = content[language];

  return (
    <section id="features" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-xs font-light text-gray-500 tracking-widest uppercase mb-3">
            {t.subtitle}
          </p>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            {t.title}
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-teal-500 to-purple-500 rounded-full mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t.description}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {t.features.map((feature, index) => (
            <div
              key={index}
              className="group bg-white rounded-3xl p-8 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
            >
              <div className={`w-16 h-16 flex items-center justify-center bg-gradient-to-br ${feature.color} rounded-2xl mb-6 group-hover:scale-110 transition-transform`}>
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
